export default __webpack_public_path__ + "static/media/f_wrapper.af680435.svg";